import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Lock, Loader2, ArrowLeft } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post("/admin/login", { email, password });
            localStorage.setItem("wynwood_admin_token", data.access_token);
            localStorage.setItem("wynwood_admin_email", data.email);
            toast.success("Welcome back.");
            navigate("/admin");
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-charcoal flex flex-col">
            <div className="p-6 md:p-10">
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 text-xs tracking-[0.25em] uppercase text-white/50 hover:text-gold"
                    data-testid="back-to-site"
                >
                    <ArrowLeft size={14} /> Back to site
                </Link>
            </div>
            <div className="flex-1 flex items-center justify-center px-6">
                <div className="w-full max-w-md">
                    <div className="text-center mb-10">
                        <div className="inline-flex w-14 h-14 rounded-full bg-gold/10 border border-gold/30 items-center justify-center mb-6">
                            <Lock className="text-gold" size={22} />
                        </div>
                        <div className="text-[11px] tracking-[0.4em] uppercase text-gold font-semibold mb-3">
                            Admin Access
                        </div>
                        <h1 className="font-display text-3xl md:text-4xl font-semibold tracking-tight">
                            Wynwood CRM
                        </h1>
                        <p className="mt-3 text-white/50 text-sm">
                            Sign in to manage your leads pipeline.
                        </p>
                    </div>
                    <form
                        onSubmit={submit}
                        className="space-y-5"
                        data-testid="admin-login-form"
                    >
                        <div>
                            <Label className="text-[11px] tracking-[0.3em] uppercase text-white/50 mb-3 block">
                                Email
                            </Label>
                            <Input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="admin@miamihomestore.com"
                                className="bg-transparent border-white/20 h-12 rounded-none focus-visible:ring-gold focus-visible:border-gold"
                                data-testid="admin-email"
                                required
                            />
                        </div>
                        <div>
                            <Label className="text-[11px] tracking-[0.3em] uppercase text-white/50 mb-3 block">
                                Password
                            </Label>
                            <Input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="bg-transparent border-white/20 h-12 rounded-none focus-visible:ring-gold focus-visible:border-gold"
                                data-testid="admin-password"
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full inline-flex items-center justify-center gap-3 bg-gold text-charcoal py-4 text-xs tracking-[0.2em] uppercase font-semibold hover:bg-gold-hover transition-colors disabled:opacity-60"
                            data-testid="admin-login-btn"
                        >
                            {loading && <Loader2 size={16} className="animate-spin" />}
                            Sign In
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
